const UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export type IdFactory = () => string;

export function isUuid(value: string): boolean {
  return UUID_PATTERN.test(value);
}

export function assertUuid(value: string, label = "ID"): string {
  if (!isUuid(value)) {
    throw new TypeError(`${label} must be a UUID.`);
  }

  return value;
}
